// Shared page title block: optional eyebrow icon/label, title, description, actions.
export function PageHeader({ icon: Icon, eyebrow, title, description, actions, children }) {
  return (
    <header className="page-header">
      <div style={{ minWidth: 0 }}>
        {(Icon || eyebrow) && (
          <div className="page-eyebrow">
            {Icon && <Icon size={14} aria-hidden="true" />}
            {eyebrow}
          </div>
        )}
        <h1>{title}</h1>
        {description && <p>{description}</p>}
        {children}
      </div>
      {actions && <div className="page-actions">{actions}</div>}
    </header>
  );
}

export function StatGrid({ children, style }) {
  return <div className="stat-grid" style={style}>{children}</div>;
}

export function Stat({ label, value, hint, icon: Icon, tone }) {
  const color = tone ? `var(--${tone})` : undefined;
  return (
    <div className="stat">
      <span className="stat-label">{Icon && <Icon aria-hidden="true" />}{label}</span>
      <span className="stat-value" style={color ? { color } : undefined}>{value}</span>
      {hint && <span className="stat-hint">{hint}</span>}
    </div>
  );
}
